import React, { useContext } from "react";

import makeStyles from '@mui/styles/makeStyles';
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import Paper from "@mui/material/Paper";

import CardMedia from "@mui/material/CardMedia";

let mhState = {
  code: "MH",
  language: { name_en: "marathi", code: "mr", name_vernacular: "मराठी" },
  name_en: "maharashtra",
  name_vernacular: "महाराष्ट्र",
};
const useStyles = makeStyles((theme) => ({
  whyGoldTitle: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.0),
  },
  infoCard: {
    background: "#FAEEEE",
  },
}));

export default function WhyReason(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  return <>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.whyGoldTitle}
    >
      <Grid item>
        <Typography
          variant={"body1"}
          align={"center"}
          style={{ fontWeight: "bold" }}
        >
          {messages["free.whyGold"][language]}
        </Typography>
      </Grid>
    </Grid>

    <Paper elevation={0} className={classes.infoCard}>
      <CardContent>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <CardMedia
              component="img"
              height="75"
              image="icons/reason1.svg"
              title={""}
              alt={""}
            />
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={8}>
            <Typography variant={"body2"}>
              {messages["free.whyGoldReason1"][language]}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
    <br />
    <Paper elevation={0} className={classes.infoCard}>
      <CardContent>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <CardMedia
              component="img"
              height="75"
              image="icons/reason2.svg"
              title={""}
              alt={""}
            />
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={8}>
            <Typography variant={"body2"}>
              {messages["free.whyGoldReason2"][language]}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
    <br />
    <Paper elevation={0} className={classes.infoCard}>
      <CardContent>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <CardMedia
              component="img"
              height="75"
              image="icons/reason3.svg"
              title={""}
              alt={""}
            />
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={8}>
            <Typography variant={"body2"}>
              {messages["free.whyGoldReason3"][language]}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  </>;
}
